import { render, staticRenderFns } from "./JobTitleEndedTaskItem.vue?vue&type=template&id=a1c778a4&"
import script from "./JobTitleEndedTaskItem.vue?vue&type=script&lang=js&"
export * from "./JobTitleEndedTaskItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports